import * as React from 'react';
import Urls from '@/config/url';
import https from '@/utils/ajaxUtils';
import storageUtils from '@/utils/storageUtils';
import config from '@/config/config';
import { message, Pagination, Modal } from 'antd';

class CaseList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginInfo: JSON.parse(storageUtils.get(config.loginStorageKey)),
      currentPage: 1,
      pageSize: 9,
      total: 0,
      EnterpriseCaseList: [],
      SimpleCaseList: [],
      SimpleCaseListByTye: [],
      onmouseoverLeftCardVis: false
    };
  }
  UNSAFE_componentWillMount() {
    console.log(this.state.loginInfo);
    this.getSimpleCaseList();
    this.getEnterpriseCaseList();

  }
  // 获取简单案例 (左侧)
  getSimpleCaseList = async () => {
    let param = {
      currentPage: 1,
      pageSize: 999
    }
    const res = await https.get(Urls.getSimpleCaseList, param);
    console.log(' 获取简单案例: ', res);
    if (!res.success) {
      message.error(' 获取简单案例失败');
      return;
    }
    this.setState({ SimpleCaseList: res.data.data }, () => {
      this.classificationByType();
    });
  }
  // 根据type分类
  classificationByType = () => {
    let arr = this.state.SimpleCaseList;
    let map = {}
    for (let i = 0; i < arr.length; i++) {
      let ai = arr[i]
      if (!map[ai.type]) {
        map[ai.type] = [ai]
      } else {
        map[ai.type].push(ai)
      }
    }
    let res = []
    Object.keys(map).forEach(key => {
      res.push({
        type: key,
        data: map[key],
        onmouseoverLeftCardVis: false,
      })
    })
    this.setState({ SimpleCaseListByTye: res }, () => {
      console.log('分类后', this.state.SimpleCaseListByTye);
    });
  }
  // 获取企业案例(分页)
  getEnterpriseCaseList = async () => {
    let param = {
      currentPage: this.state.currentPage,
      pageSize: this.state.pageSize
    }
    const res = await https.get(Urls.getEnterpriseCaseList, param);
    console.log(' 获取企业案例: ', res);
    if (!res.success) {
      message.error(' 获取企业案例失败');
      return;
    }
    this.setState({ EnterpriseCaseList: res.data.data, total: res.data.total });

  }
  toCaseDetail = (i, id, state) => {
    console.log(window.location.pathname);
    if (!this.state.loginInfo) {
      // 未登陆跳转到登录页
      console.log('未登陆');
      this.props.history.push(`/Login`);
      return;
    }
    // if (this.state.currentPage !== 1 || (this.state.currentPage === 1 && i > 0)) {
    //   Modal.warning({
    //     title: '不支持',
    //     // content: 'some messages...some messages...',
    //   });
    // } else {
    //   this.props.history.push({ pathname: "/case/detail", state: { id: id } });
    // }
    if (state && state === 'up') {
      this.props.history.push({ pathname: "/case/detail", state: { id: id } });
    } else {
      Modal.warning({
        title: '暂未开放!',
        // content: 'some messages...some messages...',
      });
    }
  }
  // 简单案例 跳转到搜索结果(传type(标识 是从案例跳过去的) 跟id)
  simpleCaseToResult = (data) => {
    console.log('data: ', data);
    if (!this.state.loginInfo) {
      // 未登陆跳转到登录页
      console.log('未登陆');
      this.props.history.push(`/Login`);
      return;
    }
    if (data.state === 'up') {
      // 状态为up 则跳转到搜索结果页
      this.props.history.push({ pathname: "/service/result", state: { id: data.id, type: 'case' } });
    } else {
      Modal.warning({
        title: '暂未开放!',
        // content: 'some messages...some messages...',
      });
    }
  }
  onmouseoverLeftCard = (type) => {
    console.log('鼠标移入');
    let SimpleCaseListByTye = this.state.SimpleCaseListByTye;
    for (let index = 0; index < SimpleCaseListByTye.length; index++) {
      const element = SimpleCaseListByTye[index];
      if (element.type === type) {
        element.onmouseoverLeftCardVis = true;
      }
    }
    this.setState({ SimpleCaseListByTye });
  }
  onmouseoutLeftCard = (type, e) => {
    console.log('鼠标移出');
    let SimpleCaseListByTye = this.state.SimpleCaseListByTye;
    for (let index = 0; index < SimpleCaseListByTye.length; index++) {
      const element = SimpleCaseListByTye[index];
      if (element.type === type) {
        element.onmouseoverLeftCardVis = false;
      }
    }
    this.setState({ SimpleCaseListByTye });
  }
  render() {
    const changePage = (page) => {
      console.log('page: ', page);
      this.setState({
        currentPage: page
      }, () => {
        this.getEnterpriseCaseList();
      });
    };
    const changePageSize = (current, size) => {
      console.log('size: ', size);
      console.log('current: ', current);
      this.setState({
        currentPage: current,
        pageSize: size
      }, () => {
        this.getEnterpriseCaseList();
      });
    };
    return (
      <React.Fragment>
        <div className="case"></div>
        <div className="index-content">
          {/* <div className="case-box"> */}
          <div className="list">
            <div className="case-top left">
              <div className="title">热门案例</div>
              {
                this.state.SimpleCaseListByTye && this.state.SimpleCaseListByTye.length > 0 &&
                this.state.SimpleCaseListByTye.map((v, i) => {
                  // return (
                  //   <div className="list-boxes" key={v.type} onMouseOver={() => { this.onmouseoverLeftCard(v.type) }} onMouseOut={() => { this.onmouseoutLeftCard(v.type) }}>
                  //     <div className="logo">
                  //       {!v.onmouseoverLeftCardVis &&
                  //         <img src={(v.data && v.data.length > 0) ? v.data[0].imgUrl : ''} alt="" style={{ width: "3.2rem", height: "2.02rem" }}></img>
                  //       }
                  //       {
                  //         v.onmouseoverLeftCardVis &&
                  //         <div style={{ width: "3.2rem", height: "2rem", overflow: 'auto' }}>
                  //           {
                  //             v.data && v.data.length > 0 &&
                  //             v.data.map((y, index) => {
                  //               return (
                  //                 <React.Fragment key={index}>
                  //                   <a onClick={() => { this.simpleCaseToResult(y) }}>
                  //                     <div style={{ width: '3.2rem', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginBottom: -20 }}>
                  //                       {index + 1}:{y.name}
                  //                     </div>
                  //                   </a>
                  //                   <br />
                  //                 </React.Fragment>
                  //               );
                  //             })
                  //           }
                  //         </div>
                  //       }
                  //     </div>
                  //   </div>
                  // );
                  return (
                    <React.Fragment key={i}>
                      <div className="list-boxes" key={v.type} onMouseEnter={() => { this.onmouseoverLeftCard(v.type) }} onMouseLeave={(e) => { this.onmouseoutLeftCard(v.type, e); }}>
                        <div className="logo">
                          {
                            !v.onmouseoverLeftCardVis &&
                            <img src={(v.data && v.data.length > 0) ? v.data[0].imgUrl : ''} alt="" style={{ width: "3.2rem", height: "2.02rem" }}></img>
                          }
                          {
                            v.onmouseoverLeftCardVis &&
                            <React.Fragment>
                              <img src={(v.data && v.data.length > 0) ? v.data[0].imgUrl : ''} alt="" style={{ width: "3.2rem", height: "2.02rem" }}></img>
                              <div className="mask"></div>
                              <div className="show">
                                {
                                  v.data && v.data.length > 0 &&
                                  v.data.map((y, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <div key={index} onClick={() => { this.simpleCaseToResult(y) }} style={{ width: '50%', display: 'inline-block', cursor: 'pointer', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#ffffff' }}>
                                          {index + 1}:{y.name}
                                        </div>
                                      </React.Fragment>
                                    );
                                  })
                                }
                              </div>
                            </React.Fragment>
                          }
                        </div>
                      </div>
                      {/* {
                        !v.onmouseoverLeftCardVis &&
                        <div className="list-boxes" key={v.type} onMouseOver={() => { this.onmouseoverLeftCard(v.type) }}>
                          <div className="logo">
                            <img src={(v.data && v.data.length > 0) ? v.data[0].imgUrl : ''} alt="" style={{ width: "3.2rem", height: "2.02rem" }}></img>
                          </div>
                        </div>
                      }
                      {
                        v.onmouseoverLeftCardVis &&
                        <div className="list-boxes" key={v.type}  onMouseOut={() => { this.onmouseoutLeftCard(v.type) }}>
                          <div className="logo">
                            <div className="mask"></div>
                            <div className="show">
                              {
                                v.data && v.data.length > 0 &&
                                v.data.map((y, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <div key={index} onClick={() => { this.simpleCaseToResult(y) }} style={{ width: '33%', display: 'inline-block', cursor: 'pointer', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#ffffff' }}>
                                        <div >
                                          {index + 1}:{y.name}
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  );
                                })
                              }
                            </div>
                          </div>
                        </div>
                      } */}
                    </React.Fragment>
                  );
                })
              }
            </div>
            {/* <div className="wier"></div> */}
            <div className="case-top right">
              <div className="title" style={{ marginLeft: '0.1rem' }}>企业案例</div>
              <div className="panel">
                {
                  this.state.EnterpriseCaseList && this.state.EnterpriseCaseList.length > 0 &&
                  this.state.EnterpriseCaseList.map((v, i) => {
                    return (
                      <div className="boxes" key={v.id} onClick={() => { this.toCaseDetail(i, v.id, v.state) }} style={{ cursor: 'pointer' }}>
                        <div className="img">
                          <img src={v.imgUrl} alt={v.name} style={{ width: "2.65rem", height: "1.5rem" }}></img>
                        </div>
                        <div className="txt">{v.name}</div>
                      </div>
                    );
                  })
                }
              </div>
              {
                this.state.EnterpriseCaseList && this.state.EnterpriseCaseList.length > 0 &&
                <div style={{ height: 20, textAlign: 'right', marginTop: 10 }}>
                  <Pagination
                    size={'small'}
                    total={this.state.total}
                    showQuickJumper={true}
                    // showSizeChanger={true}
                    current={this.state.currentPage}
                    pageSize={this.state.pageSize}
                    onChange={changePage}
                    onShowSizeChange={changePageSize}
                    showTotal={(total, range) => {
                      // const totalPage = Math.ceil(total / this.state.pageSize);
                      return '共 ' + total + ' 条';
                    }}
                  />
                </div>
              }
            </div>
          </div>
          {/* </div> */}
        </div>
      </React.Fragment >
    );
  }
}

export default CaseList;
